import React from 'react';
import { RankBadge } from './RankBadge';

/**
 * Small rank insignia overlaid on the corner of a member's avatar (comments, DMs).
 * Renders nothing for the entry rank (Cadet / months 0) to keep things clean, and
 * sits absolutely-positioned so it never pushes or overlaps message text.
 * Wrap your <Avatar> in a `relative` container and drop this inside it.
 */
export const RankAvatarBadge = ({ rank, className = '' }) => {
  if (!rank || !rank.rankName || (rank.months || 0) <= 0) return null;
  return (
    <span
      className={`absolute -bottom-1.5 -right-1.5 pointer-events-none drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)] ${className}`}
      title={`${rank.rankName}${rank.isOG ? ' · OG' : ''}`}
      data-testid="avatar-rank-badge"
    >
      <RankBadge rank={rank} size="xs" />
    </span>
  );
};

export default RankAvatarBadge;
